export default __webpack_public_path__ + "static/media/webinar.24de6d91.png";